import { apiFetch } from '../authentication/authUtils';
import { getResponseErrorTitle } from '../shared/apiUtils';

type OptionType =
    | 'string'
    | 'stringMultiline'
    | 'number'
    | 'money'
    | 'boolean'
    | 'date'
    | 'dateTime'
    | 'dateTimeUsersOffset'
    | 'singleSelect'
    | 'multiSelect'
    | 'singleSelectButtons'
    | 'multiSelectButtons'
    | 'phoneNumber'
    | 'markdown'
    | 'multiString'
    | 'password';

export interface Option {
    id: string;
    label: string;
    help: string | null;
    type: OptionType;
    isRequired: boolean;
    isVisible: boolean;
    options: Record<string, string> | null;
    exampleValue: string | null;
    suggestedDefaultValue: string | null;
}

export type AuthorizationStrategy =
    | 'oAuth2AuthorizationCode'
    | 'oAuth2ClientCredential'
    | 'apiKey'
    | 'basic'
    | 'bearerJwt';

export interface Connector {
    id: string;
    name: string;
    description: string;
    icon: string;
    userAuthOptions: Option[];
    appAuthOptions: Option[];
    boomiSuppliesAppAuthOptions: boolean;
    authorizationStrategy: AuthorizationStrategy;
    scopes: string[];
}

export async function getConnectors(): Promise<Connector[]> {
    const response = await apiFetch('/connector/metadata');

    if (!response.ok) {
        throw new Error(await getResponseErrorTitle(response));
    }

    return response.json() as Promise<Connector[]>;
}

export async function getConnector(id: string): Promise<Connector> {
    const response = await apiFetch(`/connector/${id}/metadata`);

    if (!response.ok) {
        throw new Error(await getResponseErrorTitle(response));
    }

    return response.json() as Promise<Connector>;
}
